module.exports = __webpack_public_path__ + "static/SthefanoC-ProjectsPage-67d7d1ff316a53d4bd219f7835769132.png";